import { render } from "./DuplicateOppModal.vue?vue&type=template&id=072014de"
import script from "./DuplicateOppModal.vue?vue&type=script&lang=js"
export * from "./DuplicateOppModal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__